import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=0209beef&scoped=true&"
import script from "./Part2.vue?vue&type=script&lang=js&"
export * from "./Part2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0209beef",
  null
  
)

export default component.exports